const movies = [
  {
    title: "Inception",
    year: 2010,
    rating: 8.8,
    genre: "Sci-Fi",
    poster: "https://upload.wikimedia.org/wikipedia/en/2/2e/Inception_%282010%29_theatrical_poster.jpg",
    trailer: "https://www.youtube.com/embed/YoHD9XEInc0"
  },
  {
    title: "Interstellar",
    year: 2014,
    rating: 8.6,
    genre: "Sci-Fi",
    poster: "https://image.tmdb.org/t/p/w500/rAiYTfKGqDCRIIqo664sY9XZIvQ.jpg",
    trailer: "https://www.youtube.com/embed/zSWdZVtXT7E"
  },
  {
    title: "The Dark Knight",
    year: 2008,
    rating: 9.0,
    genre: "Action",
    poster: "https://image.tmdb.org/t/p/w500/qJ2tW6WMUDux911r6m7haRef0WH.jpg",
    trailer: "https://www.youtube.com/embed/EXeTwQWrcwY"
  },

  {
    title: "Avengers: Endgame",
    year: 2019,
    rating: 8.4,
    genre: "Action",
    poster: "https://image.tmdb.org/t/p/w500/or06FN3Dka5tukK1e9sl16pB3iy.jpg",
    trailer: "https://www.youtube.com/embed/TcMBFSGVi1c"
  },
  {
    title: "Joker",
    year: 2019,
    rating: 8.4,
    genre: "Drama",
    poster: "https://image.tmdb.org/t/p/w500/udDclJoHjfjb8Ekgsd4FDteOkCU.jpg",
    trailer: "https://www.youtube.com/embed/zAGVQLHvwOY"
  },
  {
    title: "Titanic",
    year: 1997,
    rating: 7.9,
    genre: "Romance",
    poster: "https://image.tmdb.org/t/p/w500/9xjZS2rlVxm8SFx8kPC3aIGCOYQ.jpg",
    trailer: "https://www.youtube.com/embed/kVrqfYjkTdQ"
  },
  {
    title: "The Matrix",
    year: 1999,
    rating: 8.7,
    genre: "Sci-Fi",
    poster: "https://image.tmdb.org/t/p/w500/f89U3ADr1oiB1s9GkdPOEpXUk5H.jpg",
    trailer: "https://www.youtube.com/embed/vKQi3bBA1y8"
  },
  {
    title: "Spider-Man: No Way Home",
    year: 2021,
    rating: 8.2,
    genre: "Action",
    poster: "https://image.tmdb.org/t/p/w500/1g0dhYtq4irTY1GPXvft6k4YLjm.jpg",
    trailer: "https://www.youtube.com/embed/JfVOs4VSpmA"
  },
  {
    title: "Frozen II",
    year: 2019,
    rating: 6.8,
    genre: "Animation",
    poster: "https://image.tmdb.org/t/p/w500/mINJaa34MtknCYl5AjtNJzWj8cD.jpg",
    trailer: "https://www.youtube.com/embed/eSLe4HuKuK0"
  },
  {
    title: "Gladiator",
    year: 2000,
    rating: 8.5,
    genre: "Action",
    poster: "https://image.tmdb.org/t/p/w500/ty8TGRuvJLPUmAR1H1nRIsgwvim.jpg",
    trailer: "https://www.youtube.com/embed/owK1qxDselE"
  },
  {
    title: "Avatar",
    year: 2009,
    rating: 7.9,
    genre: "Sci-Fi",
    poster: "https://image.tmdb.org/t/p/w500/6EiRUJpuoeQPghrs3YNktfnqOVh.jpg",
    trailer: "https://www.youtube.com/embed/5PSNL1qE6VY"
  },
  {
    title: "The Lion King",
    year: 1994,
    rating: 8.5,
    genre: "Animation",
    poster: "https://image.tmdb.org/t/p/w500/sKCr78MXSLixwmZ8DyJLrpMsd15.jpg",
    trailer: "https://www.youtube.com/embed/4sj1MT05lAA"
  }
];

export default movies;